export default __webpack_public_path__ + "static/media/c9-interior1.98a65784.webp";